/* ── Dynamic accent-color overrides for dark pages ─── */
export function buildDarkAccentCss(accent){
  if(!accent)return "";
  const a=accent;
  return `
.p-dark::before{background:radial-gradient(circle,${a}26 0%,transparent 65%);}
.p-hero-tag-dark{color:${a};background:${a}1a;border-color:${a}40;}
.p-logo-dark-accent{background:linear-gradient(135deg,${a},${a}bb);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
.p-hero-title-dark span{background:linear-gradient(135deg,${a},${a}bb);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
.p-btn-accent-dark{background:linear-gradient(135deg,${a},${a}cc);}
.p-btn-accent-dark:hover{box-shadow:0 12px 36px ${a}50;}
.p-btn-primary-dark{background:linear-gradient(135deg,${a},${a}cc);}
.p-inp-dark:focus{border-color:${a}88;box-shadow:0 0 0 3px ${a}11;}
.p-feat-card-dark:hover{border-color:${a}40;}
.p-lang-btn-dark.active{background:${a};color:#08080f;border-color:${a};}
  `.trim();
}

/* ── Dynamic accent-color overrides for light pages ─── */
export function buildLightAccentCss(accent){
  if(!accent)return "";
  const a=accent;
  return `
.p-light::before{background:radial-gradient(circle,${a}14 0%,transparent 65%);}
.p-hero-tag-light{color:${a};background:${a}14;border-color:${a}35;}
.p-logo-light-accent{background:linear-gradient(135deg,${a},${a}bb);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
.p-hero-title-light span{color:${a};}
.p-btn-accent-light{background:${a};}
.p-btn-accent-light:hover{box-shadow:0 12px 36px ${a}40;}
.p-btn-primary-light{background:${a};}
.p-btn-primary-light:hover{box-shadow:0 8px 28px ${a}40;}
.p-inp-light:focus{border-color:${a};box-shadow:0 0 0 3px ${a}18;}
.p-feat-card-light:hover{border-color:${a}55;}
.p-lang-btn-light.active{background:${a};color:white;border-color:${a};}
  `.trim();
}
